import * as React from 'react'
import { Fund } from '../../types'
import { Table, TableCell, TableHeading, SubLabel } from '../atoms/Table'
import { A } from '../atoms/A'
import { formatWithComma } from '@/lib/number'
import { EmptyCard } from './EmptyCard'
import { Help } from './Help'
import { FormattedDate } from '../atoms/FormattedDate'

type Props = {
  list: Fund[]
  className?: string
  investorShortName?: string
}

export const FundsTable: React.FC<Props> = (props) => {
  if (props.list.length === 0) {
    return <EmptyCard />
  }

  const fundUrl = (fund: Fund) => {
    const iShortname = props.investorShortName
      ? props.investorShortName
      : fund.investorShortnames[0]
    return `/investors/${iShortname}/funds/${fund.shortname}`
  }

  return (
    <Table className="fund-table">
      <thead>
        <tr>
          <TableHeading>ファンド名</TableHeading>
          <TableHeading>
            ファンド額
            <SubLabel>百万円</SubLabel>
            <Help>出資総額</Help>
          </TableHeading>
          <TableHeading>設立年月日</TableHeading>
          <TableHeading>種別</TableHeading>
          <TableHeading>
            ファンド類型
            <Help>
              地域密着型、汎用型、業種特化型、産学連携型、シードアクセラレーター等
            </Help>
          </TableHeading>
          <TableHeading>
            重点ステージ
            <Help>
              {`シード・アーリー・エクスパンション・レータ\n・バランス型・バイアウト型・再生企業`}
            </Help>
          </TableHeading>
        </tr>
      </thead>
      <tbody>
        {props.list.map((f) => (
          <tr key={f.id}>
            <TableCell className="fund-name">
              <A href={fundUrl(f)} target="_blank" decoration="none">
                {f.name}
              </A>
            </TableCell>
            <TableCell align="right">
              {f.amount && formatWithComma(f.amount)}
            </TableCell>
            <TableCell>
              <FormattedDate>{f.established}</FormattedDate>
            </TableCell>
            <TableCell>{f.classification}</TableCell>
            <TableCell>{f.type}</TableCell>
            <TableCell>{f.stages.join(', ')}</TableCell>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}
